import { useEffect, useState } from 'react';
import useDebouncedValue from '../helpers/hooks/useDebouncedValue';



export default function useOnlineStatus(): boolean {
  const [onlineStatus, setOnlineStatus] = useState(true);
  const debouncedStatus = useDebouncedValue(onlineStatus, 3000);

  const goOnline = () => setOnlineStatus(true);

  const goOffline = () => setOnlineStatus(false);

  useEffect(() => {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return debouncedStatus;
}
